<template>
  <div id="app">
    <router-view /> <!-- Renders the active route's component -->
  </div>
</template>

<script>
export default {
  name: 'App',
};
//  @TODO how to implement skin design?

</script>

<style lang="scss">
  @import '@/resources/scss/style.scss';
</style>
